export default __webpack_public_path__ + "static/media/bubble.56009546.svg";